import * as React from 'react';
import { EOperationStatus } from 'types';
import { Preloader } from 'components/preloader';

import './style.scss';
import { IOperationsState } from 'services/operations/operations-reducer';

export interface ICaptchaProps {
    captchaOperation: IOperationsState['CAPTCHA'];
    renderInput: () => JSX.Element;
}

export interface ICaptchaState {

}

class CaptchaComponent extends React.Component<ICaptchaProps, ICaptchaState> {
    constructor(props: ICaptchaProps) {
        super(props);
    }

    getCaptchaImageUrl(captchaKey: string): string {
        if (!captchaKey) {
            return '';
        } else {
            if (__PROXY_URL__) {
                return `${__PROXY_URL__}/bitrix/tools/captcha.php?captcha_code=${captchaKey}`;
            } else {
                return `/bitrix/tools/captcha.php?captcha_code=${captchaKey}`;
            }
        }
    }

    render() {
        let { captchaOperation } = this.props;

        return (
            <div className="app-captcha-wrapper">
                <div className="app-captcha-image">
                    { captchaOperation.status === EOperationStatus.PENDING ? (
                        <Preloader />
                    ) : (
                        <img src={this.getCaptchaImageUrl(captchaOperation.data?.CAPTCHA_KEY)} />
                    ) }
                </div>

                <div className="app-captcha-input-wrapper">
                    { this.props.renderInput() }
                </div>
            </div>
        );
    }
}

export const Captcha = CaptchaComponent;
